import React, { useState, useRef } from 'react';
import t from '~t';
import getThumbUri from '~data/modules/format/thumb';

import {
  Modal,
  ModalHeader as Header,
  ModalContent as Content,
  Button,
} from '~ui';
import PickerFile from '~co/picker/file/element';
import PickerLink from '~co/picker/link';
import { Button as ButtonLegacy, Icon, Preloader } from '~ui';

export default function PickerImage({
  items = [], //[{ link }]
  selected = '', //link
  onLink, //async
  onFile, //async
  onScreenshot, //async
  onClose,
}) {
  const addLink = useRef(null);

  const [showAddLink, setShowAddLink] = useState(false);
  const [screenshotLoading, setScreenshotLoading] = useState(false);

  const handleLink = async (link) => {
    await onLink(link);
    onClose();
  };

  const handleFile = async (file) => {
    await onFile(file);
    onClose();
  };

  const onScreenshotClick = async () => {
    if (screenshotLoading) return;

    setScreenshotLoading(true);
    await onScreenshot();
    setScreenshotLoading(false);

    onClose();
  };

  const screenshotExists = items.some(({ screenshot }) => screenshot);

  return (
    <Modal onClose={onClose}>
      <Header title={t.s('cover')} data-no-shadow>
        <Button
          ref={addLink}
          variant='accent'
          title={t.s('add') + ' URL…'}
          onClick={() => setShowAddLink(true)}
        >
          <Icon name='add' />
        </Button>

        <ButtonLegacy
          as='label'
          variant='accent'
          title={t.s('uploadFile')}
        >
          <PickerFile onFile={handleFile}>
            <Icon name='upload' />
          </PickerFile>
        </ButtonLegacy>
      </Header>

      <Content>
        <div className='ui-image-picker-items'>
          {items.map(({ link }) => (
            <button
              key={link}
              className='ui-image-picker-item'
              autoFocus={selected == link}
              onClick={() => handleLink(link)}
            >
              <img
                src={`${getThumbUri(link)}?mode=crop&width=128&height=96&dpr=${
                  window.devicePixelRatio || 1
                }`}
              />
            </button>
          ))}

          {!screenshotExists ? (
            <button
              className='ui-image-picker-item'
              title={t.s('clickToMakeScreenshot')}
              onClick={onScreenshotClick}
            >
              {screenshotLoading ? <Preloader /> : t.s('screenshot')}
            </button>
          ) : null}

          {showAddLink ? (
            <PickerLink
              pin={addLink}
              onClose={() => setShowAddLink(false)}
              onLink={handleLink}
            />
          ) : null}
        </div>
      </Content>
    </Modal>
  );
}
